// extracted by mini-css-extract-plugin
export default {"btn":"BackToTop_btn__6R3DQ","visible":"BackToTop_visible__YsPhE"};